'use client';

import React, { useEffect } from 'react';

// Extend Window interface to include playlightSDK
declare global {
  interface Window {
    playlightSDK?: {
      init: () => void;
      setDiscovery: (enabled: boolean) => void;
    };
  }
}

export default function PlaylightInitialise() {
  useEffect(() => {
    try {
      window.playlightSDK?.init();
    } catch (error) {
      console.error('Error initializing the Playlight SDK:', error);
    }
  }, []);

  return <></>;
}

export function playlightShowDiscovery() {
  try {
    window.playlightSDK?.setDiscovery(true);
  } catch (error) {
    console.error('Error showing the Playlight discovery:', error);
  }
}
